import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Divider, Tabs, Tab, Card } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './EventProjectWings.module.css';
import DropDown from '../../../../Subcomponents/DropDown';
import { getProjectByProjectName } from '../../../../Services/SustenanceService';
import { AllotmentDiv } from '../../../../Subcomponents/FloorComponent/FloorComponents';
import WingsCard from '../../../../Subcomponents/WingsCard/WingsCard';
import WingsIcon from '../../../../Assets/Images/Common/noProjectFound.svg';
import { getLaunchById } from '../../../../Services/Launch';
import {
  getLaunchInventoryRelations,
  getPreSelectInventoryRelations,
  getPreSelectLaunchInventoryRelations,
  getPreSelectWings,
  getUnitsOfLaunches,
  getUnitsOfPreselect,
} from '../../../../Services/Event';
import { sortBy } from 'lodash';
import ViewToggleSwitch from '../../../../Subcomponents/ViewSwitch/ViewToggleSwitch';

function EventProjectWings() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const navigate = useNavigate();
  const [tabs, setTab] = useState([]);
  const { eventID, projectId, launchId } = useParams();
  const [AllWings, setAllWings] = useState([]);
  const [ProjectData, setProjectData] = useState([]);
  const [launchData, setLaunchData] = useState('');
  const [UnitStatus, setUnitStatus] = useState([]);
  const [TotalWings, setTotalWings] = useState(0);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [NoWingsFound, setNoWingsFound] = useState(null);
  const [mode, setMode] = useState('Card View');
  const [preSelectId, setPreSelectId] = useState([]);

  const [NoPreSelectUnitsFound, setNoPreSelectUnitsFound] = useState(null);

  const [PreSelectUnits, setPreSelectUnits] = useState([]);
  const [PreSelectKey, setPreSelectKey] = useState(false);
  const [checkedState, setCheckedState] = useState(
    new Array(PreSelectUnits?.length).fill(false)
  );

  const [tabValue, setTabValue] = useState('Event Allotment');

  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
    else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
    else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
    return val;
  }

  const handleOnChange = (value) => {
    console.log('value', value);
  };

  useEffect(() => {
    let PreSelectDetails = JSON.parse(
      sessionStorage.getItem('GlobalLeadPreSelectedLeadData')
    );
    if (PreSelectDetails) {
      console.log('PreSelectDetails', PreSelectDetails);
      console.log(
        'PreSelectDetails?.selectedEventToken?.tokenId?.tokenId',
        PreSelectDetails?.selectedEventToken?.tokenId?.tokenId
      );
      getPreSelectLaunchInventoryRelations(
        PreSelectDetails?.selectedEventToken?.tokenId?.tokenId
      )
        .then((response33) => {
          console.log('Preselect-Id-data', response33);
        })
        .catch((err) => {
          console.error('Pre-select', err);
        });
    }
  }, []);

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });
  useEffect(() => {
    dispatch(action.activeMenu('eventdirectallotment'));
    getProject();
    if (JSON.parse(sessionStorage.getItem('GlobalLeadPreSelected'))) {
      setTab(['Preselect Allotment']);
      setTabValue('Preselect Allotment');
    } else {
      setTab(['Event Allotment']);
      setTabValue('Event Allotment');
    }
    console.log('tabValue', tabValue);
  }, []);

  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
  };

  function getProject() {
    getLaunchById(launchId)
      .then((response) => {
        console.log('---->', response.data);
        setLaunchData(response.data);
      })
      .catch((err) => {
        console.error('getLaunchById', err);
      });
    //*Inventory
    getProjectByProjectName(projectId)
      .then((resp) => {
        console.log('Projects', resp);
        setProjectData(resp.data[0]);
        if (resp.data[0]) {
          let preSelectRoute1 = sessionStorage.getItem('GlobalLeadPreSelected');
          if (preSelectRoute1 === 'true') {
            console.log('preSelectRoute1', preSelectRoute1);
            let Info = JSON.parse(
              sessionStorage.getItem('GlobalLeadPreSelectedLeadData')
            );
            if (Info?.selectedEventToken?.tokenId?.isPreselect === true) {
              setPreSelectKey(true);
              console.log(
                'Info?.selectedEventToken?.eventTokenId',
                Info?.selectedEventToken?.eventTokenId
              );
              console.log('launchId---->', launchId);
              getPreSelectWings(
                Info?.selectedEventToken?.eventTokenId,
                launchId
              )
                .then((response99) => {
                  console.log('getPreSelectWings', response99);
                  if (response99.data.length > 0) {
                    setNoWingsFound(true);
                  } else {
                    setNoWingsFound(false);
                  }
                  setAllWings(response99.data);
                  setTotalWings(response99.data.length);
                })
                .catch((err) => {
                  console.error('getPreSelectWings', err);
                });

              getUnitsOfPreselect(launchId)
                .then((response44) => {
                  console.log('getUnitsOfPreselect', response44);
                  setUnitStatus(response44.data);
                  setTotalUnits(response44.count);
                })
                .catch((err) => {
                  console.error('getUnitsOfPreselect', err);
                });
            }
          } else {
            //*launchInventory
            getLaunchInventoryRelations(launchId)
              .then((response66) => {
                console.log('launchInventory', response66);
                if (response66.data.length > 0) {
                  setNoWingsFound(true);
                } else {
                  setNoWingsFound(false);
                }
                setAllWings(response66.data);
                setTotalWings(response66.data.length);
              })
              .catch((err) => {
                console.error('launchInventory', err);
              });

            getUnitsOfLaunches(launchId)
              .then((response88) => {
                console.log('launchInventory-units', response88);
                setUnitStatus(response88.data);
                setTotalUnits(response88.count);
              })
              .catch((err) => {
                console.error('launchInventory-units', err);
              });
          }
        }
      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });
  }

  function goToUnit(unit) {
    console.log('unit-details', unit);
    if (unit) {
      sessionStorage.setItem('EventUnit', 'PreSelect');
      navigate(
        `/home/Event/Details/${eventID}/DirectAllotment/${launchId}/${projectId}/${unit.wingId.wingId}/${unit.unitId.unitId}`
      );
    }
  }

  function goToWing(wingName) {
    if (PreSelectKey === true) {
      navigate(
        `/home/Event/Details/${eventID}/DirectAllotment/${launchId}/${projectId}/${wingName}`
      );
    } else {
      navigate(
        `/home/Event/Details/${eventID}/DirectAllotment/${launchId}/${projectId}/${wingName}`
      );
    }
  }
  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>
              {launchData[0]?.title}{' '}
            </Box>
            <Box>
              <Box className={cssClasses.Title}>
                Project :
                <Box
                  component={'span'}
                  className={cssClasses.NumberTitle}
                  ml={2}
                >
                  {ProjectData?.projectName}
                </Box>{' '}
              </Box>

              <Box className={cssClasses.Title}>
                Location:
                <Box
                  component={'span'}
                  className={cssClasses.NumberTitle}
                  ml={2}
                >
                  {ProjectData?.addressLine1} , {ProjectData?.addressLine2} ,{' '}
                  {ProjectData?.addressLine3}
                </Box>{' '}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Divider />
      <Tabs
        value={tabValue}
        onChange={tabChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
        sx={[
          {
            borderBottom: '1px solid #EAECF0 !important',
          },
        ]}
      >
        {tabList}
      </Tabs>

      {/* {loggedInUser?.roleId?.accessibleTabs?.Event["View Details"]["Direct Allotment"]["View Launches"]["View Wings"]?.isAccessible && (
        <> */}
      {tabValue === 'Event Allotment' && (
        <>
          <Box className={cssClasses.FirstDiv}>
            <Box className={cssClasses.Title} mt={2}>
              Total Wings :
              <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                {TotalWings}
              </Box>{' '}
            </Box>
            <Box className={cssClasses.Title} mt={2}>
              Total Units :
              <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                {TotalUnits}
              </Box>{' '}
            </Box>
            <Box margin={'1rem 2rem'}>
              <ViewToggleSwitch setMode={setMode} />
            </Box>
          </Box>

          <Divider />
          <Box className={cssClasses.BoxDiv}>
            <AllotmentDiv
              style={{ backgroundColor: '#D1FADF' }}
              content={'Available'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Available'
                    ).length
                  : '0'
              }
            />
            <AllotmentDiv
              style={{ backgroundColor: '#FEF0C7' }}
              content={'On Hold'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'On Hold'
                    ).length
                  : '0'
              }
            />
            {/* // ! to hide these status as per client requirement => 28 March, 2023 */}
            {/* <AllotmentDiv
                style={{ backgroundColor: '#FEE4E2' }}
                // content={'Alloted'}
                content={'Payment Pending'}
                Quantity={
                  UnitStatus
                    ? UnitStatus?.filter(
                        (f) => f.unitId.inventoryStatusId.status === 'Payment Pending'
                      ).length
                    : '0'
                }
              /> */}
            <AllotmentDiv
              style={{ backgroundColor: '#FFE6D5' }}
              content={'Preselected'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Preselected'
                    ).length
                  : '0'
              }
            />
            {/* <AllotmentDiv
              style={{ backgroundColor: '#EFF8FF' }}
              content={'Kyc Pending'}
              Quantity={UnitStatus
                ? UnitStatus?.filter(
                    (f) => f.unitId.inventoryStatusId.status === 'Kyc Pending').length : "0"}
            />
             <AllotmentDiv
              style={{ backgroundColor: '#ECFDFF' }}
              content={'Kyc Done'}
              Quantity={UnitStatus
                ? UnitStatus?.filter(
                    (f) => f.unitId.inventoryStatusId.status === 'Kyc Done').length : "0"}
            />
             <AllotmentDiv
              style={{ backgroundColor: '#FFFAEB' }}
              content={'SDR Payment Pending'}
              Quantity={UnitStatus
                ? UnitStatus?.filter(
                    (f) => f.unitId.inventoryStatusId.status === 'SDR Payment Pending').length : "0"}
            />
                <AllotmentDiv
                style={{ backgroundColor: '#F4EBFF' }}
                content={'Reserved'}
                Quantity={
                  UnitStatus
                    ? UnitStatus?.filter(
                        (f) => f.unitId.inventoryStatusId.status === 'Reserved'
                      ).length
                    : '0'
                }
              />
              <AllotmentDiv
                style={{ backgroundColor: '#F2F4F7' }}
                content={'Locked'}
                Quantity={
                  UnitStatus
                    ? UnitStatus?.filter(
                        (f) => f.unitId.inventoryStatusId.status === 'Locked'
                      ).length
                    : '0'
                }
              /> */}
          </Box>
          <Divider />

          {mode === 'Card View' && (
            <>
              <Box className={cssClasses.MainDiv}>
                <Box className={cssClasses.FlexRow}>
                  {sortBy(AllWings, 'wingname')?.map((wing, index) => (
                    <Box component={'span'} key={`${wing}_${index}`}>
                      <WingsCard
                        clicked={() => {
                          goToWing(wing.wingid);
                        }}
                        // wingName={wing.wingname}
                        wingName={wing.displaywingname ? wing.displaywingname : wing.wingname}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>

              {NoWingsFound === false && (
                <Box mt={2}>
                  <Box className={cssClasses.noDataMsg}>
                    <Box className={cssClasses.emptyIcon}>
                      <img src={WingsIcon} alt='No Wings Available' />
                    </Box>
                    <Box className={cssClasses.emptyTitle}>
                      No Wings were Found
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}

          {mode === 'Table View' && (
            <Box margin={'1rem'}>
              {sortBy(AllWings, 'wingname')?.map((wing, index) => (
                <Box mb={2}>
                  <Card
                    onClick={() => {
                      goToWing(wing.wingid);
                    }}
                    sx={{
                      padding: '2rem',
                      fontSize: '1.6rem',
                      fontFamily: 'Inter-Regular',
                      lineHeight: '2.4rem',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      boxShadow:
                        '0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important',
                      borderRadius: '0.8rem !important',
                      border: ' 1px solid rgba(0, 0, 0, 0.12) !important',
                      gap: '1rem',
                      cursor: 'pointer',
                    }}
                    key={`${wing}_${index}`}
                  >
                    {/* <Box>Wing {wing.wingname}</Box> */}
                    <Box>Wing {wing.displaywingname ? wing.displaywingname : wing.wingname}</Box>
                  </Card>
                </Box>
              ))}

              {NoWingsFound === false && (
                <Box>
                  <Box className={cssClasses.noDataMsg}>
                    <Box className={cssClasses.emptyIcon}>
                      <img src={WingsIcon} alt='No Wings' />
                    </Box>
                    <Box className={cssClasses.emptyTitle}>
                      No Wings were found
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </>
      )}
      {/* </>
       
      )} */}

      {tabValue === 'Preselect Allotment' && (
        <>
          <Box className={cssClasses.FirstDiv}>
            <Box className={cssClasses.Title} mt={2}>
              Total Wings :
              <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                {TotalWings}
              </Box>{' '}
            </Box>
            <Box className={cssClasses.Title} mt={2}>
              Total Units :
              <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                {TotalUnits}
              </Box>{' '}
            </Box>
            <Box margin={'1rem 2rem'}>
              <ViewToggleSwitch setMode={setMode} />
            </Box>
          </Box>
          <Divider />
          {/* {PreSelectKey === false && ( */}
          <Box className={cssClasses.BoxDiv} mt={2}>
            <AllotmentDiv
              style={{ backgroundColor: '#D1FADF' }}
              content={'Available'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Available'
                    ).length
                  : '0'
              }
            />
            <AllotmentDiv
              style={{ backgroundColor: '#FEF0C7' }}
              content={'On Hold'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'On Hold'
                    ).length
                  : '0'
              }
            />
            <AllotmentDiv
              style={{ backgroundColor: '#FFE6D5' }}
              content={'Preselected'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Preselected'
                    ).length
                  : '0'
              }
            />
            {/* <AllotmentDiv
                 style={{ backgroundColor: '#F4EBFF' }}
                 content={'Reserved'}
                 Quantity={
                   UnitStatus
                     ? UnitStatus?.filter(
                         (f) => f.unitId.inventoryStatusId.status === 'Reserved'
                       ).length
                     : '0'
                 }
               />
               <AllotmentDiv
                 style={{ backgroundColor: '#F2F4F7' }}
                 content={'Locked'}
                 Quantity={
                   UnitStatus
                     ? UnitStatus?.filter(
                         (f) => f.unitId.inventoryStatusId.status === 'Locked'
                       ).length
                     : '0'
                 }
               /> */}
          </Box>
          <Divider />
          {/* )} */}

          {mode === 'Card View' && (
            <>
              <Box className={cssClasses.MainDiv}>
                <Box className={cssClasses.FlexRow}>
                  {AllWings?.map((wing, index) => (
                    <Box component={'span'} key={`${wing}_${index}`}>
                      <WingsCard
                        clicked={() => {
                          goToWing(wing.wingid);
                        }}
                        // wingName={wing.wingname}
                        wingName={wing.displaywingname ? wing.displaywingname : wing.wingname}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>

              {NoWingsFound === false && (
                <Box mt={2}>
                  <Box className={cssClasses.noDataMsg}>
                    <Box className={cssClasses.emptyIcon}>
                      <img src={WingsIcon} alt='No Wings Available' />
                    </Box>
                    <Box className={cssClasses.emptyTitle}>
                      No Wings were Found
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}

          {mode === 'Table View' && (
            <Box margin={'1rem'}>
              {AllWings?.map((wing, index) => (
                <Box mb={2}>
                  <Card
                    onClick={() => {
                      goToWing(wing.wingid);
                    }}
                    sx={{
                      padding: '2rem',
                      // color: "#344054",
                      fontSize: '1.6rem',
                      fontFamily: 'Inter-Regular',
                      lineHeight: '2.4rem',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      // justifyContent: "space-between",
                      alignItems: 'center',
                      boxShadow:
                        '0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important',
                      borderRadius: '0.8rem !important',
                      border: ' 1px solid rgba(0, 0, 0, 0.12) !important',
                      gap: '1rem',
                      cursor: 'pointer',
                    }}
                    key={`${wing}_${index}`}
                  >
                    {/* <Box>Wing {wing.wingname}</Box> */}
                    <Box>Wing {wing.displaywingname ? wing.displaywingname : wing.wingname}</Box>
                  </Card>
                </Box>
              ))}

              {NoWingsFound === false && (
                <Box>
                  <Box className={cssClasses.noDataMsg}>
                    <Box className={cssClasses.emptyIcon}>
                      <img src={WingsIcon} alt='No Wings' />
                    </Box>
                    <Box className={cssClasses.emptyTitle}>No Wings found</Box>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default EventProjectWings;
